// @ts-ignore IntelliJ wrongly flags this with: "can only be default-imported using the esModuleInterop flag"
import objectInspect from 'object-inspect';

/**
 * Formats a JavaScript object into a JSON string for logging,
 * handling circular references and custom depth.
 *
 * @param obj         The object to format.
 * @param [depth=15]  The maximum depth to inspect the object.
 * @param [indent=2]  The number of spaces used for indents in the resulting JSON string.
 * @returns A string representation of the object.
 */
export function formatObject(obj: unknown, depth = 15, indent = 2): string {
  return objectInspect(obj, { depth, indent });
}

/**
 * Formats a list of message parts into a single log string with a timestamp.
 *
 * @param messageParts            The array of message components to join.
 * @param [timestamp=new Date()]  The timestamp for the log entry.
 * @returns The formatted string in the format `[ISO-Date] Message`.
 */
export function formatLog(messageParts: unknown[], timestamp: Date = new Date()): string {
  const messageStr = messageParts
    .map((part: unknown) => (typeof part === 'object' && part !== null ? formatObject(part) : String(part)))
    .join(' ');
  return `[${timestamp.toISOString()}] ${messageStr}`;
}
